import React, { useEffect, useCallback, useState} from 'react';
import accounts from 'accounts/Accounts.js';
import EditList from './EditList.js';
import ipfs from 'decentralized/Ipfs.js';
import {connect} from 'react-redux';

const List = (props) => { 
    const {loadWork} = props;
    const [isEditable, setIsEditable] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [list, setList] = useState({... props.list});

    let style = {
        backgroundImage: "url(" + ipfs.getHashUrl(list.image) + ")"
    };

    useEffect(() => {
        accounts.getAccount().then(
            user => {
                if (!user) {
                    return;
                }
                if (list.user) {
                    setIsEditable(user.toLowerCase() === list.user.toLowerCase());
                } else {
                    setIsEditable(true);
                }
            });
    }, [setIsEditable]);

    const doneEditing = useCallback((list) => {
        if (list) {
            setList(list);
            props.onListChanged(list);
        }
        setIsEditing(false);
    }, [setList, setIsEditing]);

    const getClassName = useCallback((work) => {
        let className = "project";
        if (props.worksLoaded.some(x => x.newSequence === work.newSequence)) {
            className += " loaded";
        }
        return className;
    }, [props.worksLoaded]);

    useEffect(() => {
        if (props.list.projects[0] && props.worksLoaded.length === 0) {
            loadWork(list.projects[0]);
        }
    }, []);

    if (isEditing) {
        return (
            <EditList onDelete={props.onDelete} list={list} hide={doneEditing}/>
        );
    }


    return (
        <div style={style} className="list">
          {isEditable ? <div onClick={() => setIsEditing(true)} className="edit-button">Edit</div> : ''}
          <div className="projects">
            {list.projects.map(
                x =>
                    <div
                      onClick={() => loadWork(x)}
                      className={getClassName(x)}>
                      {x.title}
                    </div>)}
          </div>
          <div className="list-title">{list.name}</div>
          <div onClick={props.removeList} className="delete-btn">x</div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      worksLoaded: state.explore.worksLoaded
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
